import {TableCell, TableRow} from "@material-ui/core";
import React from "react";
import {
    dateConveretedItalianFullMonthName,
    dateConvertedItalianWithFirstCapitalMonth
} from "../../../../shared/utils/dateUtils";
import StatusCardWithoutIcon
    from "../../../../shared/components/status-card/status-card-without-icon/StatusCardWithoutIcon";
import EmptyRow from "../../../ui/tables/rows/empty-row/EmptyRow";

export const headCells = [
    {id: "tipologia", align: "left", minWidth: 100, label: "Tipologia"},
    {id: "numeroDiTelefono", align: "left", minWidth: 100, label: "Numero di telefono"},
    {id: "imei", align: "left", minWidth: 100, label: "IMEI"},
    {id: "canale", align: "left", minWidth: 100, label: "Canale"},
    {id: "id", align: "left", minWidth: 100, label: "ID"},
    {id: "dataApertura", align: "left", minWidth: 100, label: "Data apertura"},
    {id: "categoria", align: "left", minWidth: 100, label: "Categoria"},
    {id: "stato", align: "left", minWidth: 100, label: "Stato", format: (value) => value.toFixed(2)},
];

export const tableRow = ({tableData, handleClickRow, count}) => {
    return (
        count !== 0 ? tableData.map((row) => {
                return (
                    <TableRow
                        hover
                        onClick={(e) => handleClickRow(e, row)}
                        role="checkbox"
                        tabIndex={-1}
                        key={row.id}
                    >
                        <TableCell align="left">{row.typology}</TableCell>
                        <TableCell align="left">{row.msisdn}</TableCell>
                        <TableCell align="left">{row.imei}</TableCell>
                        <TableCell align="left">{row.channel}</TableCell>
                        <TableCell align="left">{row.id}</TableCell>
                        <TableCell align="left">{dateConvertedItalianWithFirstCapitalMonth(row.dateOpened)}</TableCell>
                        <TableCell align="left">{row.category}</TableCell>
                        <TableCell align="right">
                            <StatusCardWithoutIcon text={row.status} color="blue"/>
                        </TableCell>
                    </TableRow>
                );
            }
        ) : (
            <EmptyRow text="dato" colSpan={headCells.length}/>
        ));
};

export const filterRadioButtons = [
    {text: "Numero di telefono", value: "msisdn"},
    {text: "ID", value: "id"},
    {text: "Categoria", value: "categoria"}
];

export const sortingCriteria = [
    {text: "Più Recente", value: "dateOpened"},
    {text: "ID", value: "rowId"},
];

export const assistenzaDetailsDialog = (props) => {
    return [
        {
            label: "data apertura",
            body: dateConveretedItalianFullMonthName(props.dateOpened),
            bodyVariant: "subtitle2"
        },
        {
            label: "data chiusura",
            body: dateConveretedItalianFullMonthName(props.dateClosed),
            bodyVariant: "subtitle2",
        },
        {
            label: "prodotto",
            body: props.product,
            bodyVariant: "subtitle2",
        },
        {
            label: "SIM / ASSET COINVOLTI",
            body: props.msisdn,
            bodyVariant: "subtitle2",
        },
        {
            label: "IMEI",
            body: props.imei,
            bodyVariant: "subtitle2",
        },
        {
            label: "Tipo",
            body: props.category,
            bodyVariant: "subtitle2",
        },
        {
            label: "canale",
            body: props.channel,
            bodyVariant: "subtitle2",
        },
        // {
        //     label: "Creato da",
        //     body: props.createdBy,
        //     bodyVariant: "subtitle2",
        // },
        {
            label: "area",
            body: props.area,
            bodyVariant: "subtitle2",
        },
        {
            label: "Descrizione",
            body: props.description,
            bodyVariant: "subtitle2",
        },
        {
            label: "referente",
            body: props.referent,
            bodyVariant: "subtitle2",
        }
    ];
}
